import React from 'react';
import _ from 'lodash';
import Draggable from 'react-draggable';
import { callStates, CalloutState, CallinState } from './commonUtil';

export const CallStateComponent = (props) => {
  // 显示呼出部分
  const showForwardCall =
    props.calloutState !== CalloutState.NOT_START;
  // 显示呼入部分
  const showCommingCall =
    props.callinState !== CallinState.NOT_START;
  const dialogLabel = showForwardCall ? _.find(callStates, { value: props.calloutState }).label : _.find(callStates, { value: props.callinState }).label;
  return (
    props.show ? <Draggable>
      <div className="call-state">
        <div className="call-state-title">{dialogLabel}</div>
        <div className='call-container'>
          {showForwardCall && <div className="call-user-detail">
            <div className="call-user-detail-info">
              <div className="name">{props.user.calleeName}</div>
              <div className="tel">{props.user.calleePhoneNum}</div>
              <div className="location">{props.user.calleePhoneLoc}</div>
            </div>
            {props.callHangEnabled && <div className='align-center-right'>
              <div className="icon-hang-phone" onClick={props.handleHangCall}></div>
              <div className="icon-hang-phone-text operate-icon-text">挂断</div>
            </div>}
          </div>}
          {showForwardCall && showCommingCall && (<div className='phone-call-delimiter' />)}
          {showCommingCall && <div className='comming-call'>
            <div className='comming-call-title'>
              <div className='comming-call-title-text'>有电话呼入</div>
              <div className="icon-comming-phone" />
            </div>
            <div className="comming-call-user-detail">
              <div className="call-user-detail-info">
                <div className="name">{props.commingUserDetail.calleeName}</div>
                <div className="tel">{props.commingUserDetail.calleePhoneNum}</div>
                <div className="location">{props.commingUserDetail.calleePhoneLoc}</div>
              </div>
              <div className='align-center-right' />
              <div className='align-center-right'>
                <div className="icon-pickup-phone" onClick={_.throttle(props.handlePickupCommingCall, 500)}></div>
                <div className="icon-pickup-phone-text operate-icon-text">接听</div>
              </div>
              <div className='align-center-right'>
                <div className="icon-ignore-phone" onClick={props.handleIgnoreCommingCall}></div>
                <div className="icon-ignore-phone-text operate-icon-text">忽略</div>
              </div>
            </div>
          </div>}
          {showForwardCall && showCommingCall && (<div className="align-center-right comming-call-answer-tip">接听新来电后，当前通话会自动挂断</div>)}
        </div>
      </div></Draggable> : null
  );
};
